import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import "./Glossary.scss";
import { useTranslation } from "react-i18next";

const Glossary = (props) => {
  const { t } = useTranslation();

  return (
    <div className={"main-glossary"}>
      <div className={"glossary-header"}>
        <Typography variant={"h1"}>
          {t("ClientDetails.Plans.GlossaryPanel.glossary")}
        </Typography>
      </div>
      <div className={"glossary-details"}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.annual_average_return_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.annual_average_return_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.annualized_total_returns_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.annualized_total_returns_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.capital_gains_tax_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.capital_gains_tax_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.contributions_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.contributions_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.cumulative_wealth_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.cumulative_wealth_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.distributions_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.distributions_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.income_title")}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.income_definition")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.income_tax_title")}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.income_tax_definition")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.pension_income_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.pension_income_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.rmd_title")}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.rmd_definition")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.risk_title")}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.risk_definition")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.social_security_income_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.social_security_income_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.standard_deviation_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.standard_deviation_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.straight_line_analysis_title"
                )}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.straight_line_analysis")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.taxable_accounts_title")}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.taxable_accounts_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.tax_deferred_accounts_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.tax_deferred_accounts_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.tax_exempt_accounts_title"
                )}
              </TableCell>
              <TableCell>
                {t(
                  "ClientDetails.Plans.GlossaryPanel.tax_exempt_accounts_definition"
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.timeline_title")}
              </TableCell>
              <TableCell>
                {t("ClientDetails.Plans.GlossaryPanel.timeline_definition")}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default Glossary;
